import { mergeFragments } from "../../mergeFragments";
import base from "./base";

export default mergeFragments([base]);
